import {NavigationMenu} from './navigation-menu';

class PageLayout {
    constructor() {}
    
    run() {
        $(function () {
            NavigationMenu.run();
        });

    }
}
export {PageLayout};
